import React, { useState, useEffect } from 'react';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { BenefitDetailsResult, ApiResponse } from '@src/api.types';
import { API } from '@src/api';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Button } from '@repo/ui';
import { LogABenefitModal } from './LogABenefitModal';
import { config } from '@uhg-abyss/web/tools/config';
import { getFeatureFlagsFromStorage } from '@src/utills/storage';
import { memberInContextAtom } from '@src/global-state';
import { useAtomValue } from 'jotai';
import { CboReferralSubmissionResults } from '@src/common/CboReferralSubmissionResults/CboReferralSubmissionResults';

export const BenefitDetailsResults = ({ Id }) => {
  const [benefitdetails, setBenefitDetails] =
    useState<BenefitDetailsResult | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showLogReferralModal, setShowLogReferralModal] = React.useState<boolean>(false);
  const [benefitReferralResponse, setBenefitReferralResponse] = useState<ApiResponse<undefined> | null | undefined>(undefined);
  const memberInContext = useAtomValue(memberInContextAtom);
  const features = config('FEATURES');

  useEffect(() => {
    async function fetchBenefitDetails(Id: string) {
      setIsLoading(true);
      const resp = await API.getBenefitDetailsByBenefitId(Id, memberInContext?.benefitPlanPlatform!);
      if (
        resp !== null &&
        resp !== undefined &&
        'status' in resp &&
        resp.status === 'success' &&
        'data' in resp
      ) {
        setBenefitDetails(resp.data as BenefitDetailsResult);
      } else {
        setBenefitDetails(null);
      }
      setIsLoading(false);
    }
    if (Id !== '') {
      fetchBenefitDetails(Id);
    }
  }, [Id,memberInContext]);
  const featureFlags = getFeatureFlagsFromStorage();

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            zIndex: 999,
            backgroundColor: '#FFFFFF',
            opacity: 0.75,
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LoadingSpinner
            size="xl"
            isLoading={isLoading}
            ariaLoadingLabel="Downloading files"
          />
        </div>
      ) : (
        ''
      )}
      <Flex direction="row" alignItems="center" style={{gap:'20px', paddingTop: 4}}>
      <Heading serif size="lg" data-cy="benefit-name">
        {benefitdetails?.benefits[0]?.sectionName}
      </Heading>
      {featureFlags?.agent_log_a_benefit?.enabled &&(
      <Button data-cy='Log-referral-button' onClick={() => {
  setShowLogReferralModal(true);
}}>
        Log Benefit Referral
      </Button>)}
      </Flex>
      {showLogReferralModal && (
        <LogABenefitModal
          onClose={() => {return setShowLogReferralModal(false)}} // Handle modal close
          isOpen={showLogReferralModal} // Ensure modal opens correctly
          defaultBenefitName={benefitdetails?.benefits[0]?.sectionName || ''}
          setBenefitReferralResponse={setBenefitReferralResponse}
        />
      )}
      {benefitReferralResponse !== undefined && (
        <CboReferralSubmissionResults
          referResp={benefitReferralResponse}
          setReferResp={setBenefitReferralResponse}
          fromBulkRefer={undefined}
          setBulkReferResp={undefined}
        />
      )}
      <br />
      {benefitdetails?.benefits[0]?.description ? (
        <React.Fragment>
          <div
            data-cy="benefit-summary-text"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: benefitdetails?.benefits[0]?.shortDescription
                ? benefitdetails?.benefits[0]?.shortDescription
                : '',
            }}
          />
          <br />
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: benefitdetails?.benefits[0]
                ?.description
                ? benefitdetails?.benefits[0]?.description
                : '',
            }}
          />
        </React.Fragment>
      ) : (
        benefitdetails?.benefits[0]?.costShares?.map(
          (benefitNetworkSection) => {
            return (
              <React.Fragment>
                <Heading
                  offset={6}
                  style={{ paddingTop: 30 }}
                  data-cy="benefit-network-type"

                   dangerouslySetInnerHTML={{ __html: benefitNetworkSection.descriptions?.join('/') ?? '' }}
                />
                <br />
                <div
                  data-cy="benefit-network-type-description"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html:
                      benefitNetworkSection.languageDescription ?? '',
                  }}
                />
              </React.Fragment>
            );
          }
        )
      )}
    </div>
  );
};
